import { combineActions, handleActions } from 'redux-actions';
import { NOTIFICATION_DEFAULT, OFFER_NOTIFICATION_INCOMING, } from '../../../notifications/sagas/audio';
import { actions } from '../../actions/personal';
import { getLocalSettings } from '../../api/personal';
export const { personalSubmitMessageWithEnter, personalSubmitMessageWithEnterSucceeded, personalSubmitMessageWithEnterFailed, personalBusylight, personalBusylightSucceeded, personalBusylightFailed, personalKeyboardShortcuts, personalKeyboardShortcutsSucceeded, personalKeyboardShortcutsFailed, personalLeftMenu, personalLeftMenuSucceeded, personalLeftMenuFailed, personalCustomCardMenu, personalCustomCardMenuSucceeded, personalCustomCardMenuFailed, personalSound, personalSoundSucceeded, personalSoundFailed, personalLastFromEmailIntegration, personalLastFromEmailIntegrationSucceeded, personalLastFromEmailIntegrationFailed, personalConversationCards, personalReplyAreaHeightSucceeded, personalAddToFavouriteQueueIdsSucceeded, personalRemoveFromFavouriteQueueIdsSucceeded, personalAddToFavouriteTeamMemberIdsSucceeded, personalRemoveFromFavouriteTeamMemberIdsSucceeded, personalToggleRememberMicrophoneAccessSucceeded, personalToggleRememberElevioCardOpen, personalChangedElevioSelectedLanguage, personalToggleRememberKnowledgeCardOpen, } = actions;
function initialState() {
    const localSettings = getLocalSettings();
    const initState = {
        submitMessageWithEnter: true,
        keyboardShortcuts: true,
        notificationSound: '',
        meta: {
            asyncStatus: 'succeeded',
        },
        busylight: {
            soundVolume: 4,
            tone: 'TelephoneNordic',
        },
        sounds: {
            pstnphone: { tone: OFFER_NOTIFICATION_INCOMING },
            widgetchat: { tone: OFFER_NOTIFICATION_INCOMING },
            email: { tone: OFFER_NOTIFICATION_INCOMING },
            messaging: { tone: OFFER_NOTIFICATION_INCOMING },
            notification: { tone: NOTIFICATION_DEFAULT },
        },
        isLeftMenuOpen: false,
        isCustomCardMenuOpen: false,
        skipMicrophoneAccess: false,
        lastUsedEmailIntegration: null,
        conversationCards: {},
        replyAreaHeight: 200,
        favouriteQueueIds: [],
        favouriteTeamMemberIds: [],
        strictSearch: false,
        elevioCardOpen: true,
        elevioSelectedLanguage: '',
        knowledgeCardOpen: true,
    };
    if (localSettings !== null) {
        if (localSettings.submitMessageWithEnter !== undefined) {
            initState.submitMessageWithEnter = localSettings.submitMessageWithEnter;
        }
        if (localSettings.notificationSound) {
            initState.notificationSound = localSettings.notificationSound;
        }
        if (localSettings.keyboardShortcuts !== undefined) {
            initState.keyboardShortcuts = localSettings.keyboardShortcuts;
        }
        if (localSettings.busylight) {
            initState.busylight = localSettings.busylight;
        }
        if (localSettings.isLeftMenuOpen) {
            initState.isLeftMenuOpen = localSettings.isLeftMenuOpen;
        }
        if (localSettings.sounds) {
            initState.sounds = localSettings.sounds;
        }
        if (localSettings.lastUsedEmailIntegration) {
            initState.lastUsedEmailIntegration =
                localSettings.lastUsedEmailIntegration;
        }
        if (localSettings.conversationCards) {
            initState.conversationCards = localSettings.conversationCards;
        }
        if (localSettings.replyAreaHeight) {
            initState.replyAreaHeight = localSettings.replyAreaHeight;
        }
        if (localSettings.favouriteQueueIds) {
            initState.favouriteQueueIds = localSettings.favouriteQueueIds;
        }
        if (localSettings.favouriteTeamMemberIds) {
            initState.favouriteTeamMemberIds = localSettings.favouriteTeamMemberIds;
        }
        if (localSettings.strictSearch) {
            initState.strictSearch = localSettings.strictSearch;
        }
        if (localSettings.skipMicrophoneAccess) {
            initState.skipMicrophoneAccess = localSettings.skipMicrophoneAccess;
        }
        if (localSettings.isCustomCardMenuOpen) {
            initState.isCustomCardMenuOpen = localSettings.isCustomCardMenuOpen;
        }
        if (typeof localSettings.elevioCardOpen === 'boolean') {
            initState.elevioCardOpen = localSettings.elevioCardOpen;
        }
        if (localSettings.elevioSelectedLanguage) {
            initState.elevioSelectedLanguage = localSettings.elevioSelectedLanguage;
        }
        if (typeof localSettings.knowledgeCardOpen === 'boolean') {
            initState.knowledgeCardOpen = localSettings.knowledgeCardOpen;
        }
    }
    return initState;
}
// Reducer
export const personal = handleActions({
    [personalSubmitMessageWithEnter.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalSubmitMessageWithEnterSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { submitMessageWithEnter: action.payload.submitMessageWithEnter, meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [personalSubmitMessageWithEnterFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalBusylight.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalBusylightSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), busylight: Object.assign(Object.assign({}, state.busylight), { tone: action.payload.busylight.tone, soundVolume: action.payload.busylight.soundVolume }) });
    },
    [personalBusylightFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalKeyboardShortcuts.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalKeyboardShortcutsSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), keyboardShortcuts: action.payload.keyboardShortcuts });
    },
    [personalKeyboardShortcutsFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalLeftMenu.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalLeftMenuSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), isLeftMenuOpen: action.payload.isLeftMenuOpen });
    },
    [personalLeftMenuFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalCustomCardMenu.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalCustomCardMenuSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), isCustomCardMenuOpen: action.payload.isCustomCardMenuOpen });
    },
    [personalCustomCardMenuFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalSound.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalSoundSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), sounds: action.payload.sounds });
    },
    [personalSoundFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalLastFromEmailIntegration.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalLastFromEmailIntegrationSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), lastUsedEmailIntegration: action.payload.lastUsedEmailIntegration });
    },
    [personalLastFromEmailIntegrationFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalLeftMenu.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [personalLeftMenuSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), isLeftMenuOpen: action.payload.isLeftMenuOpen });
    },
    [personalLeftMenuFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [personalConversationCards.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { conversationCards: Object.assign(Object.assign({}, state.conversationCards), { [action.payload.key.toString()]: action.payload.value }) });
    },
    [personalReplyAreaHeightSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { replyAreaHeight: action.payload.replyAreaHeight });
    },
    [personalToggleRememberMicrophoneAccessSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { skipMicrophoneAccess: action.payload.skipMicrophoneAccess });
    },
    [combineActions(personalAddToFavouriteQueueIdsSucceeded, personalRemoveFromFavouriteQueueIdsSucceeded).toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { favouriteQueueIds: action.payload.favouriteQueueIds });
    },
    [combineActions(personalAddToFavouriteTeamMemberIdsSucceeded, personalRemoveFromFavouriteTeamMemberIdsSucceeded).toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { favouriteTeamMemberIds: action.payload.favouriteTeamMemberIds });
    },
    [personalToggleRememberElevioCardOpen.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { elevioCardOpen: action.payload.elevioCardOpen });
    },
    [personalChangedElevioSelectedLanguage.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { elevioSelectedLanguage: action.payload.elevioSelectedLanguage });
    },
    [personalToggleRememberKnowledgeCardOpen.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { knowledgeCardOpen: action.payload.knowledgeCardOpen });
    },
}, initialState());
